import { CellContainer } from "../CellContainer";
import { StyledLink, StyledModalLink } from "./styles";
import { CellLinkProps } from "./types";

export const CellLink = ({
  to = '#',
  value,
  align = 'start',
  direction,
  gap,
  color,
  underline = 'hover',
  onClick,
  style,
  useModal = false
}: CellLinkProps) => {
  const isEmpty = value == null || value === '';

  return (
    <CellContainer
      align={align}
      direction={direction}
      gap={gap}
    >
      {useModal ? (
        <StyledModalLink
          color={color}
          underline={underline}
          className={isEmpty ? 'empty' : ''}
          style={style}
          onClick={isEmpty ? undefined : onClick}
        >
          {isEmpty ? '-' : value}
        </StyledModalLink>
      ) : (
        <StyledLink
          to={to}
          color={color}
          underline={underline}
          className={isEmpty ? 'empty' : ''}
          style={style}
        >
          {isEmpty ? '-' : value}
        </StyledLink>
      )}
    </CellContainer>
  );
};
